// facet_fields: Solr returns array [label, count, label, count, ...] or object { label: count }
export function parseFacetArray(raw) {
  if (Array.isArray(raw)) {
    const pairs = []
    for (let i = 0; i < raw.length - 1; i += 2) {
      const label = raw[i] != null && raw[i] !== '' ? String(raw[i]) : '—'
      const count = typeof raw[i + 1] === 'number' ? raw[i + 1] : Number(raw[i + 1]) || 0
      pairs.push({ label, count })
    }
    return pairs.filter((p) => p.label !== 'undefined')
  }
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    return Object.entries(raw).map(([label, count]) => ({
      label: label != null && label !== '' ? String(label) : '—',
      count: typeof count === 'number' ? count : Number(count) || 0,
    }))
  }
  return []
}

// Build report counts from facet_counts.facet_fields.disposition when available
export function reportFromFacets(report, facetFields) {
  if (!facetFields || !facetFields.disposition) return report
  const pairs = parseFacetArray(facetFields.disposition)
  const counts = { received: 0, answered: 0, answeredLater: 0, notAnswered: 0, busy: 0, failed: 0, canceled: 0 }
  pairs.forEach(({ label, count }) => {
    counts.received += count
    const u = (label || '').toUpperCase()
    if (u === 'ANSWERED') counts.answered += count
    else if (u === 'ANSWER LATER') counts.answeredLater += count
    else if (u === 'NO ANSWER' || u === 'NOANSWER') counts.notAnswered += count
    else if (u === 'BUSY') counts.busy += count
    else if (u === 'FAILED') counts.failed += count
    else if (u === 'CANCEL' || u === 'CANCELED') counts.canceled += count
  })
  return { ...report, ...counts }
}

// Map facet_fields.status labels to direction keys (incoming, outgoing, local, transferred, auto_calls)
export const STATUS_TO_DIRECTION = {
  'Incoming Call': 'incoming',
  'Out Call': 'outgoing',
  'Local Call': 'local',
  'Redirect Call': 'transferred',
  'Incoming': 'incoming',
  'Outgoing': 'outgoing',
  'Local': 'local',
  'Transferred': 'transferred',
  'Auto Call': 'auto_calls',
  'AutoCall': 'auto_calls',
}

export function directionCountsFromStatusFacet(facetFields) {
  if (!facetFields || !facetFields.status) return null
  const pairs = parseFacetArray(facetFields.status)
  const initial = { incoming: 0, outgoing: 0, local: 0, transferred: 0, auto_calls: 0 }
  const withKeys = pairs.map(({ label, count }) => {
    const key = STATUS_TO_DIRECTION[label] ?? (label && String(label).toLowerCase().includes('incoming') ? 'incoming' : label && String(label).toLowerCase().includes('out') ? 'outgoing' : null)
    return { key, count: Number(count) || 0 }
  }).filter((p) => p.key && initial[p.key] !== undefined)
  return withKeys.reduce((acc, { key, count }) => ({ ...acc, [key]: acc[key] + count }), { ...initial })
}

// Build ivr, music_hold, voicemail counts from facet_fields.ivr, .line, .voiceMail
export function ivrMusicVoiceCountsFromFacets(facetFields) {
  if (!facetFields) return null
  const result = { ivr: 0, music_hold: 0, voicemail: 0 }
  if (facetFields.ivr) {
    parseFacetArray(facetFields.ivr).forEach(({ label, count }) => {
      if (String(label).toUpperCase() === 'IVR') result.ivr += count
    })
  }
  if (facetFields.line) {
    parseFacetArray(facetFields.line).forEach(({ label, count }) => {
      if (String(label || '').toLowerCase().includes('musichold')) result.music_hold += count
    })
  }
  if (facetFields.voiceMail) {
    parseFacetArray(facetFields.voiceMail).forEach(({ label, count }) => {
      if (String(label || '').toLowerCase().includes('voicemail')) result.voicemail += count
    })
  }
  return result
}
